import { render, staticRenderFns } from "./param.vue?vue&type=template&id=fb8af0f4"
import script from "./param.vue?vue&type=script&lang=js"
export * from "./param.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports